/* ==========================================================================
 *  Function: Area popup
 * ======================================================================= */
function fn_components_area(){
	if ($( '#area-popup' ).length){
		var popupBlock = $('#area-popup'),
			popupBlockStatusText = $('.js-area-status-text'),
			popupBlockName = $('.js-area-name'),
			popupBlockSize = $('.js-area-size'),
			popupBlockPrice = $('.js-area-price');

		var areaItem, 
			areaItemStatus, 
			areaItemStatusText, 
			areaItemName, 
			areaItemPrice, 
			areaItemSize;

		
		$('.js-hover-area').mousemove(function (e) {
			areaItem = $(this);

			areaItemStatus = areaItem.attr('data-area-status');
			areaItemStatusText = areaItem.attr('data-area-status-text');
			areaItemName = areaItem.attr('data-area-name');
			areaItemPrice = areaItem.attr('data-area-price');
			areaItemSize = areaItem.attr('data-area-size');

			popupBlock.removeClass('reserved sold free').addClass(areaItemStatus);
			popupBlockStatusText.text(areaItemStatusText);
			popupBlockName.text(areaItemName);
			popupBlockSize.text(areaItemSize);
			popupBlockPrice.text(areaItemPrice);

			// showPopup(areaItem);

			var left = e.pageX - $("#area-block").offset().left - popupBlock.innerWidth() / 2;
			var top = e.pageY - ($("#area-block").offset().top - 30) - popupBlock.innerHeight();

			popupBlock.addClass(class_active).css("left", left + "px").css("top", top + "px");

			$(this).addClass(class_active);

		}), $('.js-hover-area').mouseleave(function (e) {
			popupBlock.removeClass(class_active);
			$(this).removeClass(class_active);
		});
	}
}

